/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Njohje të Reja, Bisedë, Shoqëri",
      "Numёr telefoni i pasaktё",
      "Get the app",
      "Vazhdo me Apple",
      "Vazhdo me Facebook",
      "Vazhdo me Google",
      "Hyr",
      "Regjistrohu",
      "Për të vazhduar, shkruaj në fushën më poshtë karakteret që shikon:",
      "Vazhdo",
      "Shkruaj karakteret",
      "Kontroll sigurie",
      "Ngarko përsëri",
      "Krijo fjalëkalim të ri, të cilin do ta kujtosh fare lehtë:",
      "Përditëso",
      "Konfirmo fjalëkalimin",
      "Fjalëkalimi duhet të jetë të paktën {{num}} [[characters:num]]",
      "Fjalekalimi",
      "Krijo fjalëkalim të ri",
      "Badoo - Blog",
      "Vënde pune",
      "Bisedo",
      "Qytete",
      "Menaxho cookies",
      "Të drejtat e autorit © 2006 - sot. Bumble. Të gjitha të drejtat të rezervuara.",
      "Apple dhe Apple logo janë marka tregtare të Apple Inc.{{__EOL__}}Google Play është markë tregtare e Google LLC.",
      "Shkarko",
      "Facebook",
      "Na ndiq",
      "Qendra e Ndihmës",
      "Instagram",
      "Gjuha",
      "LinkedIn",
      "Përmbledhje",
      "Badoo është pjesë e Bumble Inc.",
      "Politika e privatësisë",
      "Qendra e Sigurisë",
      "Harta e faqes",
      "Deklarata e Aktit të Skllavërisë Moderne",
      "Termat dhe kushtet",
      "Twitter",
      "Shkruaj emailin ose numrin e telefonit dhe ne do të dërgojmë udhëzimet për të krijuar një fjalëkalim të ri.",
      "Kërko fjalëkalim të ri",
      "Vendos email-in ose numrin e telefonit",
      "Fjalëkalim i harruar",
      "Modele të përdorura vetëm për qëllime ilustrative",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nuk ka nevojë të presësh për tu kombinuar.{{__EOL__}}{{__EOL__}}Hyr në biseda që shkojnë pak më thellë, dhe direkt tek gjërat e bukura. Hë pra, tek pjesa ku vërtet e njihni njëri-tjetrin.",
      "Gati për të biseduar tani?",
      "Duke u regjistruar, ti bie dakort me <a class=\"link\" href=\"{{terms_url}}\">Termat dhe Kushtet tona</a>. Mëso si i përdorim të dhënat e tua tek <a class=\"link\" href=\"{{privacy_url}}\">Politika e Privatësisë</a>",
      "Të ndihmojmë të japësh më shumë nga kush je në të vërtetë, <br />për takime që të bëjnë të ndihesh mirë.",
      "Për takime me besim të plotë.",
      "Ose",
      "Ke një llogari?",
      "Regjistrohu me email ose numër telefoni",
      "Merr nga takimet atë që do.{{__EOL__}}Pa kërkuar falje.",
      "Thjesht do të bisedosh? Është OK.{{__EOL__}}Gati për diçka serioze? Na pëlqen shumë.{{__EOL__}}{{__EOL__}}Dhe nëse ndryshon mendje, mund ta bësh absolutisht.",
      "Këtu për takime",
      "Gati për një lidhje",
      "Gati për të biseduar",
      "Tako njerëz që duan të njëjtat gjëra.",
      "{{name}}, {{age}}",
      "Siguria jote është prioriteti ynë kryesor.",
      "Qendra e Sigurisë, është një burim dijesh që përmban të gjithë mbështetjen që të duhet për takime me vetëbesim.",
      "Vizito Qendrën tonë të Sigurisë",
      "Siguria vjen e para,<br/>e dyta, dhe gjithmonë.",
      "Që në momentin e parë, mendoja që do funksiononte...",
      "Në fillim nuk po kërkoja asgjë serioze...",
      "Këshilla ime për këdo në Badoo App është që të jenë vetvetja...",
      "Histori Suksesi të Badoo",
      "Shiko më shumë histori suksesi",
      "Vlerësim__CUT__{{num}}",
      "Apple App Store",
      "Na beso. Kemi bërë bashkë miliona (e miliona e miliona) njerëz që prej 2006.",
      "{{num}}M+__CUT__Shkarkime",
      "{{num}}Mln+",
      "Google Play Store",
      "E dimë çfarë bëjmë.",
      "Hyr me email ose numër telefoni",
      "Shkruaj fjalëkalimin tënd",
      "Ke harruar fjalëkalimin?",
      "Regjistrohu",
      "Nuk ke një llogari?",
      "Hyr",
      "Regjistrohu"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "gërma",
                  "gërmat",
                  "gërmave",
                  "gërmave",
                  "gërmave"
            ],
            "singular": [
                  "gërmë",
                  "gërmën",
                  "gërmës",
                  "gërmës",
                  "gërmës"
            ]
      },
      "day": {
            "plural": [
                  "ditë",
                  "ditët",
                  "ditëve",
                  "ditëve",
                  "ditëve"
            ],
            "singular": [
                  "ditë",
                  "ditën",
                  "ditës",
                  "ditës",
                  "ditës"
            ]
      },
      "hour": {
            "plural": [
                  "orë",
                  "orët",
                  "orëve",
                  "orëve",
                  "orëve"
            ],
            "singular": [
                  "orë",
                  "orën",
                  "orës",
                  "ore",
                  "ore"
            ]
      },
      "minute": {
            "plural": [
                  "minuta",
                  "minutat",
                  "minutave",
                  "minutave",
                  "minutave"
            ],
            "singular": [
                  "minutë",
                  "minutin",
                  "minutit",
                  "minutit",
                  "minutit"
            ]
      },
      "month": {
            "plural": [
                  "muaj",
                  "muajt",
                  "muajve",
                  "muajve",
                  "muajve"
            ],
            "singular": [
                  "muaj",
                  "muajin",
                  "muajit",
                  "muajit",
                  "muajit"
            ]
      },
      "second": {
            "plural": [
                  "sekonda",
                  "sekondat",
                  "sekondave",
                  "sekondave",
                  "sekondave"
            ],
            "singular": [
                  "sekondë",
                  "sekondin",
                  "sekondit",
                  "sekondit",
                  "sekondit"
            ]
      },
      "year": {
            "plural": [
                  "vite",
                  "vitet",
                  "viteve",
                  "viteve",
                  "viteve"
            ],
            "singular": [
                  "vit",
                  "vitin",
                  "vitit",
                  "vitit",
                  "vitit"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
